import React from "react";

import { formatCurrency } from "../utils/utils";

import moment from "moment";

export default ({ id, date, amount, method, onEdit }) => {
  return (
    <div className="sale-table-item sale-table-pagos">
      <div>{moment(date, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
      <div>{formatCurrency(amount)}</div>
      <div>{method}</div>
      <div>
        {method !== "VALE DE CAJA" && onEdit && (
          <div className="sale-edit-address-icon" onClick={() => onEdit(id)}>
            <img src="/images/support-extra/editar.svg" />
          </div>
        )}
      </div>
    </div>
  );
};
